import { remove as removeDiacritics } from 'diacritics';

export const slugifyString = (string = '') => removeDiacritics(string).replace(/\s\s+|-/g, ' ').replace(/\s+/g, '-').toLowerCase();
